import React,{ useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Dropdown from '../Dropdown';
import Button from '../Button';
import './style.css';

/**
 * @name SortDrop
 * @function
 * @description Displays SortDrop
 * @returns {JSX}
 * @param {*} props 
 */
const YearDrop = props  => {
    
    const [ selected, setSelected ] = useState( props.labels[ 'All-Label' ] )
    const containerEle = useRef( null );

    /**
     * @name select
     * @param {Object} e Browser event object
     * @description Applies the selected value to the list of publications
     */
    const select = e => {
        setSelected( e.currentTarget.dataset.value );
        containerEle.current.classList.remove( 'open' );

        props.callback({
            type: 'filter',
            filter: Number( e.currentTarget.dataset.value )
        });
    }
    
    return (
        <div className="dropdown" ref={containerEle}>
            <label>{ props.labels[ 'Year-Label' ] }</label>
            <Button id="year" label= { selected }  icon={ true }/>
            <Dropdown callback={ select } label={ props.labels[ 'Year-Label' ] } options={ props.decades }/>
        </div>
           
    );
}


YearDrop.propTypes = {
    labels: PropTypes.object.isRequired,
    callback: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    decades: state.archives.decades
});

export default connect( mapStateToProps )( YearDrop );

